export class PaymentMethodRequest {
    
    success: boolean;
	message: string;
	statusCard: string;
	uuid: string;

	constructor() {
	}
}